import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { css } from "styled-components";


type Props = WidgetProps

const borderStyle = {
    css: css`
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid ${UCSColors.gray07};
    `,
};

const ContentBorder: React.FC<Props> = () => {

    return <StyledWrapper {...borderStyle}>
    </StyledWrapper>
};

const widgetModule: WidgetModule = {
    component: ContentBorder,
    definition: {
        group: "Basic",
        fieldDefinitions: [],
    },
};

export default widgetModule;
